import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ImageIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 26.5 26.5",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 26.5),
    children: [/*#__PURE__*/jsx("rect", {
      width: "25",
      height: "25",
      x: ".75",
      y: ".75",
      rx: "1.5"
    }), /*#__PURE__*/jsx("circle", {
      cx: "18.25",
      cy: "8.25",
      r: "3.333"
    }), /*#__PURE__*/jsx("path", {
      d: "M4.318 16.537a9.1 9.1 0 0112.993 4.61M15.897 18.714a4.943 4.943 0 016.5-.139"
    })]
  });
};

export { PM2ImageIcon };
//# sourceMappingURL=image.js.map
